import { Component, ElementRef, OnInit } from '@angular/core';
import { Address } from 'src/app/models/address.model';
import { UserData } from 'src/app/models/userData.model';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-organization-profile',
  templateUrl: './organization-profile.component.html',
  styleUrls: ['./organization-profile.component.less']
})
export class OrganizationProfileComponent implements OnInit {
  activeTab: string = "section1";
  address: string = "";
  searchResults: Address[] = [];
  addressList: Address[] = [];
  userData: UserData | undefined;
  constructor(private elRef: ElementRef, private loginService: LoginService) { }

  scrollToAnchor(anchor: string) {
    this.activeTab = anchor;
    const element = this.elRef.nativeElement.querySelector(`#${anchor}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  getAddressList(): void {
    this.loginService.getOrganizationList().subscribe(res => {
      this.addressList = res.rtnData;
      this.handleSearchByAddress();
    })
  }
  chooseAddress(address: Address): void {
    let params = {
      "customerCode":address.customerCode,
      "shippingCode": address.customerCode,
    };
    this.loginService.setAsDefault(params).subscribe(res => {
      this.getAddressList();
    });
  }
  handleSearchByAddress(): void {
    if (!this.address) {
      //No search filter, show all addresses.
      this.searchResults = this.addressList;
    } else {
      this.searchResults = this.addressList.filter(addressItem =>
        addressItem.customerCode.toLowerCase().includes(this.address.trim().toLowerCase()));
    }
  }


  ngOnInit(): void {
    this.getAddressList();
    this.loginService.userData$.subscribe((userData: any) => {
      this.userData = userData;
    })
  }

}
